import { PocDetail } from '../business/business.types';

export enum LocationKeys {
  RESTAURANT = 'restaurant',
  DELIVERY = 'delivery',
  BUSINESS = 'business',
}

export interface LocationRequestType {
  id: number;
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  type: LocationKeys;
  building: string;
  apartment: string;
  street: string;
  state: string;
  city: string;
  country: string;
  zipCode: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface ILocationInitialValues {
  locationName: string;
  restaurantName: string;
  phoneNo: string;
  address: string;
  building: string;
  zipCode: string;
  city: string;
  state: string;
  stateIso: string;
  workplaceId: string;
  latitude: number;
  longitude: number;
  pocInfo: PocDetail[];
}
